export default __webpack_public_path__ + "static/media/akshay_kumar.651b3fe1.jpeg";